import React, { useEffect, useState } from "react";
import Header from "../component/Header";
import axios from "axios";
import { useNavigate } from "react-router-dom";

import { AesDecrypt } from "../middleware/AesDecrypt";
import { AesEncrypt } from "../middleware/AesEncrypt";
import { Base_url } from "../config";

const VideoKyc = () => {
  const navigate = useNavigate();

  const [data, setData] = useState([]);

  const [showModal, setShowModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);

  // Pagination
  const [page, setPage] = useState(0);
  const [limit] = useState(10);
  const [totalCount, setTotalCount] = useState(0);

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    User();
  }, [page]);

  const User = async () => {
    try {
      setLoading(true);

      const token = localStorage.getItem("token");

      const payload = {
        token,
        limit: limit,
        skip: page * limit,
      };

      console.log("Pagination Payload:", payload);

      const encryptedData = await AesEncrypt(payload);

      const response = await axios.post(
        Base_url + "/admin2/video_kyc",
        {
          data: encryptedData,
        }
      );

      const decrypted = AesDecrypt(response.data);
      const result = JSON.parse(decrypted);

      console.log(result);

      if (result.status === true) {
        setData(result.data || []);

        // Backend should return total count
        setTotalCount(result.count || 0);
      } else {
        alert(result.message);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const openVideo = (user) => {
    setSelectedUser(user);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setSelectedUser(null);
  };

  const updateVideoKycStatus = async (userId, status) => {
    try {
      const token = localStorage.getItem("token");

      const payload = {
        token,
        user_id: userId,
        video_kyc: status,
      };

      const encryptedData = await AesEncrypt(payload);

      const response = await axios.post(
        Base_url + "/admin2/update_video_kyc",
        {
          data: encryptedData,
        }
      );

      const decrypted = AesDecrypt(response.data);
      const result = JSON.parse(decrypted);

      if (result.status) {
        alert("Status Updated");

        // Update modal immediately
        setSelectedUser((prev) => ({
          ...prev,
          video_kyc: status,
        }));

        // Reload current page
        User();
      } else {
        alert(result.message);
      }
    } catch (err) {
      console.log(err);
      alert("Something went wrong");
    }
  };

  const convertDateString = (dateString) => {
    if (!dateString) return "-";

    const now = new Date(dateString);

    const day = String(now.getDate()).padStart(2, "0");
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const year = now.getFullYear();

    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");
    const seconds = String(now.getSeconds()).padStart(2, "0");

    return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
  };

  // Total pages
  const totalPages = Math.ceil(totalCount / limit);

  // Go to page
  const changePage = (newPage) => {
    if (newPage < 0) return;
    if (newPage >= totalPages) return;

    setPage(newPage);
  };

  return (
    <div>
      <div className="row">
        <Header />

        <div
          className="col-10"
          style={{
            overflowY: "scroll",
            height: "100vh",
            scrollbarWidth: "none",
            padding: "20px",
          }}
        >
          <h3>Video KYC</h3>

          <hr />

          {/* TABLE */}

          <div className="table-responsive">
            <table className="table table-bordered table-striped">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Name</th>
                  <th>Phone</th>
                  <th>Email</th>
                  <th>Status</th>
                  <th>Date</th>
                  <th>Video</th>
                </tr>
              </thead>

              <tbody>
                {loading ? (
                  <tr>
                    <td
                      colSpan="7"
                      className="text-center"
                    >
                      Loading...
                    </td>
                  </tr>
                ) : data?.length > 0 ? (
                  data.map((item, index) => (
                    <tr key={item._id}>
                      <td>
                        {page * limit + index + 1}
                      </td>

                      <td>{item.name}</td>

                      <td>{item.phoneno}</td>

                      <td>{item.email}</td>

                      <td>
                        <span
                          className={`badge ${
                            item.video_kyc === "success"
                              ? "bg-success"
                              : item.video_kyc === "failed"
                              ? "bg-danger"
                              : "bg-warning text-dark"
                          }`}
                        >
                          {item.video_kyc}
                        </span>
                      </td>

                      <td>
                        {convertDateString(
                          item.updatedAt
                        )}
                      </td>

                      <td>
                        <button
                          className="btn btn-primary btn-sm"
                          onClick={() =>
                            openVideo(item)
                          }
                        >
                          View Video
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan="7"
                      className="text-center"
                    >
                      No Records Found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* PAGINATION */}

          {totalCount > 0 && (
            <div
              className="d-flex justify-content-between align-items-center mt-3"
            >
              {/* Showing */}

              <div>
                Showing{" "}
                <strong>
                  {page * limit + 1}
                </strong>{" "}
                -{" "}
                <strong>
                  {Math.min(
                    (page + 1) * limit,
                    totalCount
                  )}
                </strong>{" "}
                of{" "}
                <strong>{totalCount}</strong>
              </div>

              {/* Pagination */}

              <nav>
                <ul className="pagination mb-0">

                  {/* Previous */}

                  <li
                    className={`page-item ${
                      page === 0
                        ? "disabled"
                        : ""
                    }`}
                  >
                    <button
                      className="page-link"
                      onClick={() =>
                        changePage(page - 1)
                      }
                      disabled={page === 0}
                    >
                      Previous
                    </button>
                  </li>

                  {/* Page Numbers */}

                  {Array.from(
                    { length: totalPages },
                    (_, index) => (
                      <li
                        key={index}
                        className={`page-item ${
                          page === index
                            ? "active"
                            : ""
                        }`}
                      >
                        <button
                          className="page-link"
                          onClick={() =>
                            changePage(index)
                          }
                        >
                          {index + 1}
                        </button>
                      </li>
                    )
                  )}

                  {/* Next */}

                  <li
                    className={`page-item ${
                      page === totalPages - 1
                        ? "disabled"
                        : ""
                    }`}
                  >
                    <button
                      className="page-link"
                      onClick={() =>
                        changePage(page + 1)
                      }
                      disabled={
                        page === totalPages - 1
                      }
                    >
                      Next
                    </button>
                  </li>
                </ul>
              </nav>
            </div>
          )}

          {/* VIDEO MODAL */}

          {showModal && selectedUser && (
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backgroundColor:
                  "rgba(0,0,0,0.7)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 9999,
              }}
            >
              <div
                style={{
                  width: "800px",
                  maxWidth: "95%",
                  maxHeight: "95vh",
                  overflowY: "auto",
                  background: "#fff",
                  padding: "20px",
                  borderRadius: "10px",
                }}
              >
                {/* HEADER */}

                <div className="d-flex justify-content-between align-items-center mb-3">
                  <h4>
                    Video KYC Review
                  </h4>

                  <button
                    className="btn btn-danger"
                    onClick={closeModal}
                  >
                    X
                  </button>
                </div>

                {/* USER DETAILS */}

                <div className="mb-3">
                  <strong>Name:</strong>{" "}
                  {selectedUser.name}

                  <br />

                  <strong>Phone:</strong>{" "}
                  {selectedUser.phoneno}

                  <br />

                  <strong>Email:</strong>{" "}
                  {selectedUser.email} 
                </div>

                <div className="row " >

                  <div className="col-6 " >
                    <p>Pan Data</p>
                    <hr />
                    <p>Pan No : {selectedUser.pan?.pan}</p>
                    <p>Pan Name : {selectedUser.pan?.registered_name}</p>
                    <p>Gender : {selectedUser.pan?.gender}</p>
                    <p>Masked Aadhar : {selectedUser.pan?.masked_aadhaar_number}</p>
                    <p>DOB : {selectedUser.pan?.date_of_birth}</p>
                    <p>Address : {selectedUser.pan?.address}</p>
                    
                    
                  </div>

                  <div className="col-6 " >
                    <p>Aadhar Data</p>
                    <hr />
                    <p>Aadhar No ( or ) Phone no : {selectedUser.aadhar?.aadhar_no}</p>
                    <p>Aadhar Name : {selectedUser.aadhar?.name}</p>
                    <p>Gender : {selectedUser.aadhar?.gender}</p> 
                    <p>DOB : {selectedUser.aadhar?.dob}</p> 
                  </div>
                </div>

                {/* VIDEO */}

                <video
                  width="100%"
                  height="450"
                  controls
                  autoPlay
                  style={{
                    background: "#000",
                    borderRadius: "8px",
                  }}
                >
                  <source
                    src={
                      selectedUser.video_kyc_s3_video
                    }
                    type="video/mp4"
                  />

                  Your browser does not
                  support video.
                </video>

                {/* STATUS */}

                <div className="mt-4">
                  <label className="form-label">
                    <strong>
                      Video KYC Status
                    </strong>
                  </label>

                  <select
                    className="form-control"
                    value={
                      selectedUser.video_kyc
                    }
                    onChange={(e) =>
                      updateVideoKycStatus(
                        selectedUser._id,
                        e.target.value
                      )
                    }
                  >
                    <option value="proccessing">
                      Processing
                    </option>

                    <option value="success">
                      Success
                    </option>

                    <option value="failed">
                      Failed
                    </option>
                  </select>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default VideoKyc;